import BaseModel from "./BaseModel";
import { WithdrawRequestAttributes } from "../attributes/withdraw-request-attributes";

class WithdrawRequest extends BaseModel {
    id: number;
    wallet_type: number;
    amount: string;
    amount_currency: string;
    icip_commission_amount: string;
    icip_commission_currency: string;
    company_name: string;
    validation_date: string;

    constructor(
        id: number,
        wallet_type: number,
        amount: string,
        icip_commission_amount: string, 
        amount_currency: string,
        icip_commission_currency: string,
        company_name: string,
        validation_date: string | null,
        created_at: Date | null
    ) {
        super(created_at)

        this.id = id;
        this.wallet_type = wallet_type;
        this.amount = amount;
        this.icip_commission_amount = icip_commission_amount;
        this.validation_date = validation_date;
        this.amount_currency = amount_currency;
        this.company_name = company_name;
        this.icip_commission_currency = icip_commission_currency;
    }

    static fromJson(json: WithdrawRequestAttributes): WithdrawRequest | null {
        if (json === null || json === undefined) {
            return null;
        }

        return new WithdrawRequest(
            json.id,
            json.wallet_type,
            json.amount,
            json.icip_commission_amount,
            json.amount_currency,
            json.icip_commission_currency,
            json.company_name,
            json.validation_date,
            json.created_at
        );
    }
}

export default WithdrawRequest;